import type { AgnesImageSize, TryOnOptions } from "./types";

export const APP_NAME = "美甲试戴";

export const AGNES_MODEL = "agnes-image-2.1-flash";

export const DEFAULT_OPTIONS: TryOnOptions = {
  size: "auto",
  styleStrength: "balanced",
  notes: "",
  cropMode: "contain"
};

export const OUTPUT_SIZES: AgnesImageSize[] = ["1024x1024", "1024x768", "768x1024"];

export const TRYON_PROMPT_TEMPLATE =
  "Apply the nail art from the second reference image onto the fingernails in the first hand photo. Preserve hand shape, skin tone, fingers, jewelry, background, lighting, camera angle, and composition. Only change the nails. Produce realistic salon try-on result.";

export const LOCAL_HISTORY_LIMIT = 20;

